// import React from 'react'
// import '../assets/css/Privacy.css'
// function Privacy() {
//   return (
//     <>
     
//     <div className='p-cont'>
//    <p><strong>Privacy Policy</strong> </p> 
//     <p>
//                   boardroom built the boardroom app as
//                   a Free app. This SERVICE is provided by
//                   boardroom at no cost and is intended for use as
//                   is.
//                 </p> <p>
//                   This page is used to inform visitors regarding our
//                   policies with the collection, use, and disclosure of Personal
//                   Information if anyone decided to use our Service.
//                 </p> <p>
//                   If you choose to use our Service, then you agree to
//                   the collection and use of information in relation to this
//                   policy. The Personal Information that we collect is
//                   used for providing and improving the Service. We will not use or share your information with
//                   anyone except as described in this Privacy Policy.
//                 </p> <p>
//                   The terms used in this Privacy Policy have the same meanings
//                   as in our Terms and Conditions, which are accessible at
//                   boardroom unless otherwise defined in this Privacy Policy.
//                 </p> <p><strong>Information Collection and Use</strong></p> <p>
//                   For a better experience, while using our Service, we
//                   may require you to provide us with certain personally
//                   identifiable information, including but not limited to email,user. The information that
//                   we request will be retained by us and used as described in this privacy policy.
//                 </p> <div><p>
//                     The app does use third-party services that may collect
//                     information used to identify you.
//                   </p> <p>
//                     Link to the privacy policy of third-party service providers used
//                     by the app
//                   </p> <ul><li><a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener noreferrer">Google Play Services</a></li>
                  
//                   </ul></div> <p><strong>Log Data</strong></p> <p>
//                   We want to inform you that whenever you
//                   use our Service, in a case of an error in the app
//                   we collect data and information (through third-party
//                   products) on your phone called Log Data. This Log Data may
//                   include information such as your device Internet Protocol
//                   (“IP”) address, device name, operating system version, the
//                   configuration of the app when utilizing our Service,
//                   the time and date of your use of the Service, and other
//                   statistics.
//                 </p> <p><strong>Cookies</strong></p> <p>
//                   Cookies are files with a small amount of data that are
//                   commonly used as anonymous unique identifiers. These are sent
//                   to your browser from the websites that you visit and are
//                   stored on your device's internal memory.
//                 </p> <p>
//                   This Service does not use these “cookies” explicitly. However,
//                   the app may use third-party code and libraries that use
//                   “cookies” to collect information and improve their services.
//                   You have the option to either accept or refuse these cookies
//                   and know when a cookie is being sent to your device. If you
//                   choose to refuse our cookies, you may not be able to use some
//                   portions of this Service.
//                 </p> <p><strong>Service Providers</strong></p> <p>
//                   We may employ third-party companies and
//                   individuals due to the following reasons:
//                 </p> <ul className='listp'>
//                     <li>To facilitate our Service;</li> 
//                     <li>To provide the Service on our behalf;</li>
//                      <li>To perform Service-related services; or</li>
//                       <li>To assist us in analyzing how our Service is used.</li>
//                       </ul> <p>
//                   We want to inform users of this Service
//                   that these third parties have access to their Personal
//                   Information. The reason is to perform the tasks assigned to
//                   them on our behalf. However, they are obligated not to
//                   disclose or use the information for any other purpose.
//                 </p> <p><strong>Security</strong></p> <p>
//                   We value your trust in providing us your
//                   Personal Information, thus we are striving to use commercially
//                   acceptable means of protecting it. But remember that no method
//                   of transmission over the internet, or method of electronic
//                   storage is 100% secure and reliable, and we cannot
//                   guarantee its absolute security.
//                 </p> <p><strong>Links to Other Sites</strong></p> <p>
//                   This Service may contain links to other sites. If you click on
//                   a third-party link, you will be directed to that site. Note
//                   that these external sites are not operated by us.
//                   Therefore, we strongly advise you to review the
//                   Privacy Policy of these websites. We have
//                   no control over and assume no responsibility for the content,
//                   privacy policies, or practices of any third-party sites or
//                   services.
//                 </p> <p><strong>Children’s Privacy</strong></p> <div><p>
//                     These Services do not address anyone under the age of 13.
//                     We do not knowingly collect personally
//                     identifiable information from children under 13 years of age. In the case
//                     we discover that a child under 13 has provided
//                     us with personal information, we immediately
//                     delete this from our servers. If you are a parent or guardian
//                     and you are aware that your child has provided us with
//                     personal information, please contact us so that
//                     we will be able to do the necessary actions.
//                   </p></div>  <p><strong>Changes to This Privacy Policy</strong></p> <p>
//                   We may update our Privacy Policy from
//                   time to time. Thus, you are advised to review this page
//                   periodically for any changes. We will
//                   notify you of any changes by posting the new Privacy Policy on
//                   this page.
//                 </p> <p>This policy is effective as of 2024-12-30</p> <p><strong>Contact Us</strong></p> <p>
//                   If you have any questions or suggestions about our
//                   Privacy Policy, do not hesitate to contact us at test@gmail.com.
//                 </p> 
//     </div>

      
//     </>
//   )
// }

// export default Privacy


import React from 'react'
import './Privacy.css'

function Privacy() {
  return (
    
   <div className='privacy-container'>
    <a href='/dashboard' className="" style={{position:'absolute'}}>Home</a>
<h3 className='center'>DATA PROTECTION NOTICE FOR CUSTOMERS</h3>



 <p>This Data Protection Notice (<b>“Notice”</b>) sets out the basis which Fiber One Asia Pte Ltd (<b>“we”</b>, <b>“us”</b>, or <b>“our”</b>) may collect, use, disclose or otherwise process personal data of our customers in accordance with the Personal Data Protection Act (<b>“PDPA”</b>). This Notice applies to personal data in our possession or under our control, including personal data in the possession of organisations which we have engaged to collect, use, disclose or process personal data for our purposes. </p>
<h3 className='bold'>PERSONAL DATA </h3>
<ol>
  <li>1.	As used in this Notice:

<b>“customer”</b> means an individual who (a) has contacted us through any means to find out more about any goods or services we provide, or (b) may, or has, entered into a contract with us for the supply of any goods or services by us; and

<b>“personal data”</b> means data, whether true or not, about a customer who can be identified: (a) from that data; or (b) from that data and other information to which we have or are likely to have access. 
</li>
  <li>2.	Depending on the nature of your interaction with us, some examples of personal data which we may collect from you include name, email address, telephone number, gender, photograph and employment information.  </li>
  <li>3.	Other terms used in this Notice shall have the meanings given to them in the PDPA (where the context so permits).</li>

  </ol>



<h3 className='bold'>PURPOSE OF BOARDROOM BOOKING</h3>

<ol>
  <li>1.	This privacy policy governs your use of the BoardRoom Booking mobile application (the “Application”) for mobile devices that was created by Fiber One Asia Pte Ltd (“us”)</li>
  <li>2.	The Application allows you, as the user of this Application, to:
    <ol>
      <li>a.	Book meeting room</li>
      <li>b.	Book hotdesk</li>
      <li>c.	Register new user account</li>
      <li>d.	View scheduled bookings and booking history</li>
    </ol>
  </li>
</ol>









<h3 className='bold'>COLLECTION, USE AND DISCLOSURE OF PERSONAL DATA</h3>	

<ol>
 
  <li>4.	We generally do not collect your personal data unless (a) it is provided to us voluntarily by you directly or via a third party who has been duly authorised by you to disclose your personal data to us (your <b>“authorised representative”</b> ) after (i) you (or your authorised representative) have been notified of the purposes for which the data is collected, and (ii) you (or your authorised representative) have provided written consent to the collection and usage of your personal data for those purposes, or (b) collection and use of personal data without consent is permitted or required by the PDPA or other laws. We shall seek your consent before collecting any additional personal data and before using your personal data for a purpose which has not been notified to you (except where permitted or authorised by law).</li>
  <li>5.	We may collect and use your personal data for any or all of the following purposes:
    <ol>
      <li>(a)	performing obligations in the course of or in connection with our provision of the goods and/or services requested by you;</li>
      <li>(b)	verifying your identity; and</li>
      <li>(c)	any other purposes for which you have provided the information.</li>
    </ol>
  </li>
  <li>6.	We may disclose your personal data:
    <ol>
      <li>(a)	where such disclosure is required for performing obligations in the course of or in connection with our provision of the goods and services requested by you.</li>
    </ol>
  </li>
</ol>


<h3 className='bold'>WITHDRAWING YOUR CONSENT </h3>	

<ol>
  <li>7.	The consent that you provide for the collection, use and disclosure of your personal data will remain valid until such time it is being withdrawn by you in writing. You may withdraw consent and request us to stop collecting, using and/or disclosing your personal data for any or all of the purposes listed above by submitting your request in writing or via email to our Data Protection Officer at the contact details provided below.</li>
  <li>8.	Upon receipt of your written request to withdraw your consent, we may require reasonable time (depending on the complexity of the request and its impact on our relationship with you) for your request to be processed and for us to notify you of the consequences of us acceding to the same, including any legal consequences which may affect your rights and liabilities to us. In general, we shall seek to process your request within ten (10) business days of receiving it. </li>
  <li>9.	Whilst we respect your decision to withdraw your consent, please note that depending on the nature and scope of your request, we may not be in a position to continue providing our goods or services to you and we shall, in such circumstances, notify you before completing the processing of your request. Should you decide to cancel your withdrawal of consent, please inform us in writing in the manner described in clause 7 above. </li>
  <li>10.	Please note that withdrawing consent does not affect our right to continue to collect, use and disclose personal data where such collection, use and disclose without consent is permitted or required under applicable laws.</li>
</ol>





<h3 className='bold'>ACCESS TO AND CORRECTION OF PERSONAL DATA </h3>	


<ol>
  <li>11.	If you wish to make (a) an access request for access to a copy of the personal data which we hold about you or information about the ways in which we use or disclose your personal data, or (b) a correction request to correct or update any of your personal data which we hold about you, you may submit your request in writing or via email to our Data Protection Officer at the contact details provided below. </li>
  <li>12.	Please note that a reasonable fee may be charged for an access request. If so, we will inform you of the fee before processing your request. </li>
  <li>13.	We will respond to your request as soon as reasonably possible. In general, our response will be within thirty (30) business days. Should we not be able to respond to your request within thirty (30) days after receiving your request, we will inform you in writing within thirty (30) days of the time by which we will be able to respond to your request. If we are unable to provide you with any personal data or to make a correction requested by you, we shall generally inform you of the reasons why we are unable to do so (except where we are not required to do so under the PDPA</li>
</ol>

<h3 className='bold'>PROTECTION OF PERSONAL DATA </h3>	

<ol>
  <li>14.	To safeguard your personal data from unauthorised access, collection, use, disclosure, copying, modification, disposal or similar risks, we have introduced appropriate administrative, physical and technical measures such as minimised collection of personal data, authentication and access controls (such as good password practices, need-to-basis for data disclosure, etc.), encryption of data, securely erase storage media in devices before disposal, web security measures against risks, and usage of one time password(otp)/2 factor authentication (2fa)/multi-factor authentication (mfa) to secure access. </li>
  <li>15.	You should be aware, however, that no method of transmission over the Internet or method of electronic storage is completely secure. While security cannot be guaranteed, we strive to protect the security of your information and are constantly reviewing and enhancing our information security measures.</li>

</ol>

<h3 className='bold'>ACCURACY OF PERSONAL DATA </h3>

<ol>
  <li>16.	We generally rely on personal data provided by you (or your authorised representative). In order to ensure that your personal data is current, complete and accurate, please update us if there are changes to your personal data by informing our Data Protection Officer in writing or via email at the contact details provided below.</li>
</ol>

<h3 className='bold'>RETENTION OF PERSONAL DATA </h3>

<ol>
  <li>17.	We may retain your personal data for as long as it is necessary to fulfil the purpose for which it was collected, or as required or permitted by applicable laws.</li>
  <li>18.	We will cease to retain your personal data, or remove the means by which the data can be associated with you, as soon as it is reasonable to assume that such retention no longer serves the purpose for which the personal data was collected, and is no longer necessary for legal or business purposes.</li>
</ol>


<h3 className='bold'>TRANSFERS OF PERSONAL DATA OUTSIDE OF SINGAPORE </h3>

<ol>
  <li>
  19.	We generally do not transfer your personal data to countries outside of Singapore. However, if we do so, we will obtain your consent for the transfer to be made and we will take steps to ensure that your personal data continues to receive a standard of protection that is at least comparable to that provided under the PDPA.
  </li>
</ol>

<h3 className='bold'>DATA PROTECTION OFFICER </h3>
<ol>
  <li>20.	You may contact our Data Protection Officer if you have any enquiries or feedback on our personal data protection policies and procedures, or if you wish to make any request, in the following manner:</li>
</ol>
<p><b>Contact No.      :</b> +65 6635 2366</p>
<p><b>Email Address  :</b> dpo@fiber-transmission.com</p>



<h3 className='bold'>EFFECT OF NOTICE AND CHANGES TO NOTICE </h3>

<ol>
  <li>21.	This Notice applies in conjunction with any other notices, contractual clauses and consent clauses that apply in relation to the collection, use and disclosure of your personal data by us.</li>
  <li>22.	We may revise this Notice from time to time without any prior notice. You may determine if any such revision has taken place by referring to the date on which this Notice was last updated. Your continued use of our services constitutes your acknowledgement and acceptance of such changes. </li>
</ol>

<p><b>Effective date	:</b> 	13/12/2022</p>
<p><b>Last updated	:</b> 	13/12/2022</p>


   </div>
  )
}

export default Privacy